import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65a1d043"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "InboundRow" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "InboundRow__white" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "№ ", -1))
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "InboundRow__white" }
const _hoisted_8 = { class: "InboundRow" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "InboundRow__white" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "InboundRow__white" }
const _hoisted_13 = { class: "InboundRow" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "InboundRow__white" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "InboundRow__white" }
const _hoisted_18 = { class: "InboundRow" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "InboundRow__white" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "InboundRow__white" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "font-semibold" }
const _hoisted_25 = { class: "font-semibold" }
const _hoisted_26 = { class: "font-semibold" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Выберите причину опоздания из списка ниже.", -1))
const _hoisted_28 = { class: "mb-2 font-semibold" }
const _hoisted_29 = { class: "grid gap-4" }
const _hoisted_30 = { class: "Trip px-10 py-6" }
const _hoisted_31 = {
  key: 0,
  class: "Trip__box"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении детальной информации произошла ошибка", -1))
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "flex items-center justify-between" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = {
  key: 0,
  class: "Trip__project-tag"
}
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-65a1d043><g clip-path=\"url(#clip0_4877_2043)\" data-v-65a1d043><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.4007 2.16091C11.1205 2.3322 11.8079 2.61759 12.438 3.00552L13.7618 2.41755L15.3221 3.97787L14.7343 5.3013C15.1224 5.93146 15.4078 6.61915 15.5791 7.33916L16.9298 7.859V10.0656L16.4728 10.2415C16.2164 9.99107 15.8661 9.83634 15.4808 9.83634H13.6273C13.6781 9.55267 13.7046 9.2606 13.7046 8.96232C13.7046 6.24107 11.4986 4.03505 8.77734 4.03505C6.05609 4.03505 3.85008 6.24107 3.85008 8.96232C3.85008 11.6191 5.95289 13.7844 8.58488 13.8855V14.2482C8.58488 14.6887 8.75578 15.0631 9.03789 15.3701V17.1147H7.67406L7.15406 15.7637C6.43426 15.5924 5.7468 15.307 5.11676 14.9191L3.79289 15.5071L2.23258 13.9468L2.82039 12.6233C2.4323 11.9932 2.14695 11.3054 1.97563 10.5854L0.625 10.0656V7.85904L1.97586 7.33908C2.14715 6.61923 2.43254 5.93166 2.82055 5.30162L2.23262 3.97791L3.79289 2.41755L5.11676 3.00552C5.7468 2.61759 6.43426 2.3322 7.15406 2.16091L7.6741 0.809937H9.88062L10.4007 2.16091ZM11.6384 12.0536V13.2931C11.6384 13.5559 11.8534 13.771 12.1163 13.771H16.4686C16.7315 13.771 16.9465 13.5559 16.9465 13.2931V12.0536H11.6384ZM13.3557 16.1201C13.3557 16.6375 13.7751 17.0569 14.2925 17.0569C14.8098 17.0569 15.2293 16.6375 15.2293 16.1201C15.2293 15.6044 14.8115 15.1833 14.2925 15.1833C13.7734 15.1834 13.3557 15.6044 13.3557 16.1201ZM18.9219 15.1023C19.1895 14.8826 19.375 14.6083 19.375 14.2482V12.4347C19.375 12.2248 19.2038 12.0536 18.9938 12.0536H17.5716V13.2931C17.5716 13.9008 17.0764 14.396 16.4687 14.396H12.1163C11.5085 14.396 11.0134 13.9009 11.0134 13.2931V12.0536H9.59105C9.38113 12.0536 9.20992 12.2248 9.20992 12.4347V14.2483C9.20992 14.6083 9.39539 14.8826 9.66293 15.1023C10.3896 15.6987 11.839 15.8649 12.7412 15.9387C12.8312 15.1619 13.4914 14.5584 14.2925 14.5584C15.0932 14.5584 15.7533 15.1615 15.8436 15.9379C16.7442 15.864 18.1964 15.6978 18.9219 15.1023ZM9.66293 15.8569V18.4461C9.66293 18.8552 9.9977 19.19 10.4068 19.19H18.178C18.5871 19.19 18.9219 18.8552 18.9219 18.4461V15.857C18.2537 16.2312 17.0884 16.4692 15.788 16.571C15.5944 17.2136 14.998 17.6819 14.2924 17.6819C13.5868 17.6819 12.9904 17.2136 12.7968 16.5711C11.4966 16.4693 10.3313 16.2313 9.66293 15.8569ZM16.2769 11.4286V11.2574C16.2769 10.8196 15.9187 10.4613 15.4808 10.4613H13.1042C12.6663 10.4613 12.3081 10.8196 12.3081 11.2574V11.4286H13.0129V11.2574C13.0129 11.2086 13.0554 11.1661 13.1042 11.1661H15.4809C15.5297 11.1661 15.5722 11.2086 15.5722 11.2574V11.4286H16.2769ZM5.91621 8.36044C5.57816 8.69849 5.57812 9.25169 5.91621 9.58974L7.26824 10.9418C7.65043 11.324 8.22695 11.4991 8.65793 11.0681L11.6386 8.08744C11.9767 7.74935 11.9767 7.19619 11.6386 6.85814V6.8581C11.3006 6.52005 10.7474 6.52005 10.4093 6.8581L8.02629 9.24115L7.14555 8.3604C6.80742 8.02232 6.25426 8.02236 5.91621 8.36044Z\" fill=\"white\" data-v-65a1d043></path></g><defs data-v-65a1d043><clipPath id=\"clip0_4877_2043\" data-v-65a1d043><rect width=\"20\" height=\"20\" fill=\"white\" data-v-65a1d043></rect></clipPath></defs></svg>", 1)
const _hoisted_38 = { class: "flex items-center gap-3" }
const _hoisted_39 = {
  key: 0,
  class: "Trip__small-box mt-4"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle Trip__subtitle-red" }, "ЗАФИКСИРОВАНО ОПОЗДАНИЕ", -1))
const _hoisted_41 = {
  key: 0,
  class: "Trip__no-data"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список пуст", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "Trip__Table"
}
const _hoisted_45 = { class: "flex items-center justify-between mt-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Чтобы перевести рейс на стадию подписания РПП, укажите причину опоздания.", -1))
const _hoisted_47 = {
  key: 1,
  class: "Trip__content"
}
const _hoisted_48 = { class: "Trip__grid" }
const _hoisted_49 = { class: "Trip__small-box" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "ОСНОВНАЯ ИНФОРМАЦИЯ", -1))
const _hoisted_51 = { class: "SmallGrid" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Филиал", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Маршрут", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Перевозчик", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Водитель", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Контакты", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Авто", -1))
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Тип перевозки", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Грузоподъемность авто", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Вместимость", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Заявка логиста", -1))
const _hoisted_65 = { class: "Trip__small-box" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "ДАТА", -1))
const _hoisted_67 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_68 = { class: "SmallGrid gap-0" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Дата создания:", -1))
const _hoisted_70 = { class: "SmallGrid gap-0" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Ориентировочный срок прибытия:", -1))
const _hoisted_72 = { class: "SmallGrid gap-0" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Дата прибытия:", -1))
const _hoisted_74 = { class: "SmallGrid gap-0" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Плановая дата отгрузки:", -1))
const _hoisted_76 = { class: "SmallGrid gap-0" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Фактическая дата отгрузки:", -1))
const _hoisted_78 = { class: "SmallGrid gap-0" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Расчёт по SLA:", -1))
const _hoisted_80 = { class: "Trip__small-box" }
const _hoisted_81 = { class: "Trip__subtitle" }
const _hoisted_82 = { class: "Trip__micro-title" }
const _hoisted_83 = { class: "SmallGrid" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Ставка", -1))
const _hoisted_85 = { class: "flex items-center" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "С НДС", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "ТГ/кг", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, [
  /*#__PURE__*/_createTextVNode("ТГ/м"),
  /*#__PURE__*/_createElementVNode("sup", null, "3")
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "РПП", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_91 = { class: "Trip__small-box" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "АНАЛИТИКА", -1))
const _hoisted_93 = { class: "SmallGrid" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Фактический вес", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SmallTitle" }, "Объем", -1))
const _hoisted_96 = { class: "Trip__small-box mt-4" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "ТТН", -1))
const _hoisted_98 = {
  key: 0,
  class: "Trip__no-data"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список ТТН пуст", -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = {
  key: 1,
  class: "Trip__Table"
}
const _hoisted_102 = {
  key: 0,
  class: "Trip__small-box mt-4"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "КОММЕНТАРИИ ПО СЕБЕСТОИМОСТИ", -1))
const _hoisted_104 = {
  key: 0,
  class: "Trip__no-data"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список пуст", -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 1,
  class: "Trip__Table"
}
const _hoisted_108 = {
  key: 1,
  class: "Trip__small-box mt-4"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "КОММЕНТАРИИ ПО ОПОЗДАНИЯМ", -1))
const _hoisted_110 = {
  key: 0,
  class: "Trip__no-data"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список пуст", -1))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = {
  key: 1,
  class: "Trip__Table"
}
const _hoisted_114 = {
  key: 2,
  class: "Trip__small-box mt-4"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Trip__subtitle" }, "КОММЕНТАРИИ ПО ЗАКРЫТИЮ РЕЙСА", -1))
const _hoisted_116 = { class: "Trip__Table" }
const _hoisted_117 = {
  key: 2,
  class: "Trip__box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_workplace_timer = _resolveComponent("workplace-timer")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_trips_detailed_delay_info_row = _resolveComponent("trips-detailed-delay-info-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_trips_detailed_tms_row = _resolveComponent("trips-detailed-tms-row")!
  const _component_trips_detailed_bid_details_row = _resolveComponent("trips-detailed-bid-details-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.update_popup.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Редактировать ТТН",
          loading: _ctx.update_popup.is_loading,
          onSubmit: _ctx.onSubmitUpdateTtn,
          onCancel: _ctx.onCancelUpdateTtn
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_input, {
              placeholder: "Новая плановая дата прибытия",
              type: "datetime-local",
              value: _ctx.update_popup.newExpectedDate,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.update_popup.newExpectedDate) = $event)),
              disabled: _ctx.update_popup.is_loading,
              "is-invalid": _ctx.update_popup_form$.newExpectedDate.$error,
              "validation-errors": _ctx.update_popup_form$.newExpectedDate.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
            _createVNode(_component_new_select, {
              "can-deselect": "",
              class: "my-2",
              placeholder: "Выберите причину",
              disabled: _ctx.update_popup.is_loading,
              loading: _ctx.data_state.general_comments.is_loading,
              failed: _ctx.data_state.general_comments.is_failed,
              "search-without-refresh": "",
              options: _ctx.data_state.general_comments.list,
              value: _ctx.update_popup.commentId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.update_popup.commentId) = $event)),
              "is-invalid": _ctx.update_popup_form$.commentId.$error,
              "validation-errors": _ctx.update_popup_form$.commentId.$errors,
              onRefresh: _ctx.loadGeneralComments
            }, null, 8, ["disabled", "loading", "failed", "options", "value", "is-invalid", "validation-errors", "onRefresh"]),
            _createVNode(_component_new_input, {
              placeholder: "Комментарий",
              value: _ctx.update_popup.commentInfo,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.update_popup.commentInfo) = $event)),
              disabled: _ctx.update_popup.is_loading
            }, null, 8, ["value", "disabled"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isComments)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 1,
          title: _ctx.getCommentsTitle,
          scrollable: "",
          loading: _ctx.state.is_comments_loading,
          "transparent-header": "",
          onSubmit: _ctx.sendComment,
          onCancel: _ctx.toggleComments
        }, {
          default: _withCtx(() => [
            (_ctx.isCommentInbound)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createTextVNode(" Рейс: "),
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_router_link, {
                          class: "text-blue-500 underline",
                          to: `/tms/trips/${_ctx.state.trip.id}`,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.state.trip.id), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(" Направление: "),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.state.trip.direction || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(" Плановая дата отгрузки: "),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.state.trip.plannedDateOfLoad || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode(" Фактическая дата отгрузки: "),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.state.trip.actualDateOfLoad || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(" Плановая дата прибытия: "),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.state.trip.plannedAt || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode(" Фактическая дата прибытия: "),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.state.trip.arrivalAt || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(" SLA по направлению: "),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.state.trip.sla || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createTextVNode(" Опоздание: "),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_workplace_timer, {
                          "delayed-time": _ctx.state.trip.delayedTime
                        }, null, 8, ["delayed-time"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_new_select, {
                    "can-deselect": "",
                    class: "my-2",
                    placeholder: "Выберите причину",
                    loading: _ctx.data_state.comments.is_loading,
                    failed: _ctx.data_state.comments.is_failed,
                    disabled: _ctx.state.is_comments_loading || _ctx.data_state.comments.is_loading,
                    "search-without-refresh": "",
                    options: _ctx.data_state.comments.list,
                    value: _ctx.state.commentIdInbound,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.commentIdInbound) = $event)),
                    "is-invalid": !_ctx.state.commentIdInbound,
                    onRefresh: _ctx.loadComments
                  }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "onRefresh"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCommentOutbound)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" Рейс № "),
                    _createVNode(_component_router_link, {
                      class: "text-blue-500 underline",
                      to: `/tms/trips/${_ctx.state.trip.id}`,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.trip.id), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createTextVNode(" по направлению "),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.state.trip.direction), 1),
                    _createTextVNode(" должен был отгрузиться "),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.state.delayItem.date), 1),
                    _createTextVNode(". ")
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Фактическая дата прибытия: "),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getTodayDate), 1),
                    _createTextVNode(". ")
                  ]),
                  _hoisted_27,
                  _createVNode(_component_new_select, {
                    "can-deselect": "",
                    class: "my-2",
                    placeholder: "Выберите причину",
                    loading: _ctx.data_state.comments.is_loading,
                    failed: _ctx.data_state.comments.is_failed,
                    disabled: _ctx.state.is_comments_loading || _ctx.data_state.comments.is_loading,
                    "search-without-refresh": "",
                    options: _ctx.data_state.comments.list,
                    value: _ctx.state.commentIdOutbound,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.commentIdOutbound) = $event)),
                    "is-invalid": !_ctx.state.commentIdOutbound,
                    onRefresh: _ctx.loadComments
                  }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "onRefresh"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state_cancel.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 2,
          title: "Отменить рейс",
          loading: _ctx.state_cancel.is_loading,
          onSubmit: _ctx.cancelTrip,
          onCancel: _ctx.toggleCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_select, {
              name: "Выберите комментарий",
              value: _ctx.state_cancel.commentId,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state_cancel.commentId) = $event)),
              placeholder: "Выберите из списка",
              options: _ctx.comments_state.list,
              loading: _ctx.comments_state.is_loading,
              failed: _ctx.comments_state.is_failed,
              disabled: _ctx.comments_state.is_loading,
              "is-invalid": _ctx.state_form$.commentId.$error,
              "validation-errors": _ctx.state_form$.commentId.$errors,
              "error-text": "При получении списка комментариев произошла ошибка",
              "search-without-refresh": ""
            }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"]),
            (_ctx.isComment)
              ? (_openBlock(), _createBlock(_component_the_textarea, {
                  key: 0,
                  value: _ctx.state_cancel.commentInfo,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state_cancel.commentInfo) = $event)),
                  "is-invalid": _ctx.state_form$.commentInfo.$error,
                  "validation-errors": _ctx.state_form$.commentInfo.$errors,
                  class: "w-full mt-2",
                  placeholder: "Комментарий",
                  rows: 5,
                  autoheight: ""
                }, null, 8, ["value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state_cost.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 3,
          title: "Редактирование себестоимости",
          loading: _ctx.state_cost.is_loading,
          onSubmit: _ctx.editCost,
          onCancel: _ctx.toggleCost
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_28, " Сумму необходимо вносить " + _toDisplayString(`${_ctx.state.trip.isNds ? 'с' : 'без'}`) + " НДС ", 1),
            _createVNode(_component_new_input, {
              placeholder: "Себестоимость",
              disabled: _ctx.state_cost.is_loading,
              value: _ctx.state_cost.cost,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state_cost.cost) = $event)),
              "is-invalid": _ctx.cost_form$.cost.$error,
              "validation-errors": _ctx.cost_form$.cost.$errors
            }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.done_state.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 4,
          title: "Завершение рейса",
          class: "NewModal__square",
          loading: _ctx.done_state.is_loading,
          onSubmit: _ctx.onDoneSubmit,
          onCancel: _ctx.onDoneClose
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_new_input, {
                placeholder: "Комментарий",
                disabled: _ctx.done_state.is_loading,
                value: _ctx.done_state.comment,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.done_state.comment) = $event)),
                "is-invalid": _ctx.done_state_validation$.comment.$error,
                "validation-errors": _ctx.done_state_validation$.comment.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
              _createVNode(_component_new_select, {
                "can-deselect": "",
                class: "my-2",
                placeholder: "Выберите инициатора",
                loading: _ctx.data_state.initiators.is_loading,
                failed: _ctx.data_state.initiators.is_failed,
                disabled: _ctx.data_state.initiators.is_loading || _ctx.done_state.is_loading,
                "search-without-refresh": "",
                options: _ctx.data_state.initiators.list,
                value: _ctx.done_state.initiatorId,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.done_state.initiatorId) = $event)),
                "is-invalid": _ctx.done_state_validation$.initiatorId.$error,
                "validation-errors": _ctx.done_state_validation$.initiatorId.$errors,
                onRefresh: _ctx.loadInitiators
              }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "validation-errors", "onRefresh"]),
              _createVNode(_component_new_input, {
                placeholder: "Дата закрытия",
                type: "date",
                disabled: _ctx.done_state.is_loading,
                value: _ctx.done_state.closingDate,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.done_state.closingDate) = $event)),
                "is-invalid": _ctx.done_state_validation$.closingDate.$error,
                "validation-errors": _ctx.done_state_validation$.closingDate.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
            ])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.trip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_32,
                    _createVNode(_component_new_button, {
                      class: "mt-3",
                      onClick: _ctx.loadTrip
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Обновить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (!_ctx.state.trip)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" Нет данных ")
                    ], 64))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_page_title, { title: _ctx.pageTitle }, null, 8, ["title"]),
                (_ctx.state.trip.isProject)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _hoisted_37,
                      _createTextVNode(" Проект ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.trip.status)
                  ? (_openBlock(), _createBlock(_component_cheap, {
                      key: 1,
                      class: _normalizeClass(_ctx.getCheapClass)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.state.trip.status.name), 1)
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                (_ctx.state.trip.isAdditionalLoad)
                  ? (_openBlock(), _createBlock(_component_cheap, {
                      key: 2,
                      class: "small blue--outline ml-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Догруз ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_new_button, {
                  loading: _ctx.state.is_trip_print_loading,
                  onClick: _ctx.printTrip
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Распечатать рейс ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                (_ctx.havePermissions(['all-root-permission']) && !_ctx.isComplete)
                  ? (_openBlock(), _createBlock(_component_new_button, {
                      key: 0,
                      onClick: _ctx.onDone
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Завершить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.isCancel)
                  ? (_openBlock(), _createBlock(_component_new_button, {
                      key: 1,
                      onClick: _ctx.toggleCancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отменить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.getDelayRows && _ctx.getDelayRows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  (!_ctx.getDelayRows || _ctx.getDelayRows.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_component_new_table, {
                          columns: _ctx.DELAY_INFO_COLUMNS,
                          rows: _ctx.getDelayRows,
                          "fit-content-height": ""
                        }, {
                          td: _withCtx(({ column, row }) => [
                            _createVNode(_component_trips_detailed_delay_info_row, {
                              column: column,
                              row: row
                            }, null, 8, ["column", "row"])
                          ]),
                          _: 1
                        }, 8, ["columns", "rows"])
                      ])),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode(_component_new_button, {
                      class: "NewButton--small",
                      onClick: _ctx.toggleComments
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Указать причину ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.trip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.warehouseName), 1),
                        _hoisted_53,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.fromCity ? _ctx.state.trip.fromCity.name : '...') + " - " + _toDisplayString(_ctx.state.trip.toCity ? _ctx.state.trip.toCity.name : '...'), 1),
                        _hoisted_54,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.company ? _ctx.state.trip.company.shortName : '-'), 1),
                        _hoisted_55,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.courier ? _ctx.state.trip.courier.fullName : '-'), 1),
                        _hoisted_56,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.courier ? _ctx.state.trip.courier.phoneNumber : '-'), 1),
                        _hoisted_57,
                        (_ctx.state.trip.car)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.car.model), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.car.number), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_59, "-")),
                        _hoisted_60,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.transportType ? _ctx.state.trip.transportType.name : '-'), 1),
                        _hoisted_61,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.capacity || '0') + " кг", 1),
                        _hoisted_62,
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.state.trip.cubature || '0') + " м", 1),
                          _hoisted_63
                        ]),
                        _hoisted_64,
                        _createElementVNode("p", null, [
                          _createVNode(_component_router_link, {
                            target: "_blank",
                            to: `/bids/new/${_ctx.state.trip.bidId}`,
                            class: "font-semibold text-blue-500"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Перейти ")
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDateTime(_ctx.state.trip.dates.createdDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.trip.dates.expectedDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.trip.dates.arrivalDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.trip.plannedDateOfLoad)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.trip.actualDateOfLoad)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.trip.dates.expectedDateWithSla)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createTextVNode(" ОПЛАТА "),
                        _createElementVNode("p", _hoisted_82, " Сумма указана " + _toDisplayString(`${_ctx.state.trip.isNds ? 'с' : 'без'}`) + " НДС ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.state.trip.costOfTransportation || '-'), 1),
                          _createElementVNode("i", {
                            class: "EditCost fas fa-pen",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleCost && _ctx.toggleCost(...args)))
                          })
                        ]),
                        _hoisted_86,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.isNds ? 'Да' : 'Нет'), 1),
                        _hoisted_87,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.costPerWeight || '-'), 1),
                        _hoisted_88,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.costPerCubature || '-'), 1),
                        _hoisted_89,
                        _hoisted_90
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createElementVNode("div", _hoisted_93, [
                        _hoisted_94,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.totalWeight) + " кг (" + _toDisplayString(_ctx.state.trip.carLoadedPercent) + "%) ", 1),
                        _hoisted_95,
                        _createElementVNode("p", null, _toDisplayString(_ctx.state.trip.totalCubature) + " (" + _toDisplayString(_ctx.state.trip.loadedVolumePercent) + "%) ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _hoisted_97,
                    (!_ctx.state.trip.ttns || _ctx.state.trip.ttns.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, _hoisted_100))
                      : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                          _createVNode(_component_new_table, {
                            columns: _ctx.TABLE_COLUMNS,
                            rows: _ctx.state.trip.ttns
                          }, {
                            td: _withCtx(({ column, row }) => [
                              _createVNode(_component_trips_detailed_tms_row, {
                                column: column,
                                row: row,
                                index: _ctx.state.trip.ttns.indexOf(row),
                                onUpdate: _ctx.onStartUpdateTtn
                              }, null, 8, ["column", "row", "index", "onUpdate"])
                            ]),
                            _: 1
                          }, 8, ["columns", "rows"])
                        ]))
                  ]),
                  (_ctx.state.trip.bidDetails || _ctx.state.trip.bidDetails.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                        _hoisted_103,
                        (!_ctx.state.trip.bidDetails || _ctx.state.trip.bidDetails.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_104, _hoisted_106))
                          : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                              _createVNode(_component_new_table, {
                                columns: _ctx.BID_DETAILS_COLUMNS,
                                rows: _ctx.state.trip.bidDetails,
                                "fit-content-height": ""
                              }, {
                                td: _withCtx(({ column, row }) => [
                                  _createVNode(_component_trips_detailed_bid_details_row, {
                                    column: column,
                                    row: row
                                  }, null, 8, ["column", "row"])
                                ]),
                                _: 1
                              }, 8, ["columns", "rows"])
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.delay_state.list && _ctx.delay_state.list.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                        _hoisted_109,
                        (!_ctx.delay_state.list || _ctx.delay_state.list.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, _hoisted_112))
                          : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              _createVNode(_component_new_table, {
                                columns: _ctx.DELAY_INFO_COMMENTS_COLUMNS,
                                rows: _ctx.delay_state.list,
                                "fit-content-height": ""
                              }, {
                                td: _withCtx(({ column, row }) => [
                                  _createVNode(_component_trips_detailed_delay_info_row, {
                                    column: column,
                                    row: row
                                  }, null, 8, ["column", "row"])
                                ]),
                                _: 1
                              }, 8, ["columns", "rows"])
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.trip && _ctx.state.trip.isEarlyCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        _hoisted_115,
                        _createElementVNode("div", _hoisted_116, [
                          _createVNode(_component_new_table, {
                            columns: _ctx.CLOSE_DETAILS_COLUMNS,
                            rows: _ctx.state.closedRows,
                            "fit-content-height": ""
                          }, {
                            td: _withCtx(({ column, row }) => [
                              (column.key === 'rpp')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (row[column.key])
                                      ? (_openBlock(), _createBlock(_component_router_link, {
                                          key: 0,
                                          class: "text-blue-500",
                                          target: "_blank",
                                          to: `/rpp/ltl/${row.rpp.id}`
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(row.rpp.pbsNumber), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("-")
                                        ], 64))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(row[column.key]), 1)
                                  ], 64))
                            ]),
                            _: 1
                          }, 8, ["columns", "rows"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_117, "Нет данных"))
          ]))
    ])
  ], 64))
}